const style = {
  root: {
    padding: '20px',
  },
}

export default style
